module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_2.146bc9c0.eot";